import React, { Fragment, useEffect } from "react";
import Select, { components } from "react-select";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import { MiniSpinner } from "../layouts/Spinner";
import {  Show, useAccess } from "react-redux-permission";
import { numberFormat, onlyNumber } from "../../Utils/Common";


function POSSetting() {
    return (
        <div className="card">
            <ReactTooltip  effect="solid" event="click"/>
            <div className="card-header pb-0">
                <h4 className="card-title">Settings <a href="#" className="tool-tip" data-tip="this is a tool tip"><i className="la la-question-circle"></i></a></h4>
                <a className="heading-elements-toggle"><i className="la la-ellipsis-v font-medium-3"></i></a>
                <div className="heading-elements">
                    <ul className="list-inline mb-0"></ul>
                </div>
            </div>
            <div className="card-content collapse show">
                <div className="card-body">
                
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
	pos: state.pos
})

export default connect(mapStateToProps, { })(POSSetting);

